import { rgb2hex } from '@/common/colors';

const SvgMixin = {
  methods: {
    filterLayers (id, conditionCallback) {
      const patch = this.canvas.select(`#${id}`).get(0);
      const layers = patch.select('[data-name*="Layer"]');
      return layers.members.filter(conditionCallback);
    },

    createInsertSvg (svgText, needWrapper = false, id, width, height) {
      this.canvas.select(`#${this.canvasId}--wrapper`).members[0].svg(svgText);
      const NEW_INSERT_ID = 'Layer_1';
      const insertElement = this.canvas.select(`#${NEW_INSERT_ID}`).get(0);

      if (id) {
        insertElement.id(id).addClass('insert-element');
      }
      if (width !== undefined) {
        insertElement.width(width);
      }
      if (height !== undefined) {
        insertElement.height(height);
      }

      if (needWrapper) {
        const children = insertElement.children();
        const groupWrapper = this.canvas.group().id(`${id}--wrapper`).addClass('svg-group-wrapper');
        insertElement.add(groupWrapper);
        children.forEach((child) => {
          child.putIn(groupWrapper);
        });
      }

      return insertElement;
    },

    getColorsByProperty (id, idProp, propName) {
      const mainLayers = this.filterLayers(id, (layer) => {
        const layerId = layer.id();
        return !layerId.includes('MEMBER') && layerId.includes(idProp);
      });

      return mainLayers.map((layer) => {
        const path = (layer.type === 'g') ? layer.select('path').get(0) : layer;
        let color = '#000000';
        const prop = path.style(propName);
        if (prop) {
          color = rgb2hex(prop);
        }
        return {
          color,
          layerId: layer.id(),
          order: layer.attr()['data-order'] || null,
          material: layer.attr()['data-material'] || null
        };
      });
    },

    changeColorsData (colors, layerId, newColor) {
      return colors.filter((item) => !!item).map((colorData) => {
        if (colorData.layerId === layerId) {
          return {
            ...colorData,
            color: newColor.hex
          };
        }
        return colorData;
      });
    },

    changeSvgElementColor (id, newColor, layerId) {
      const layerMembers = this.filterLayers(id, (layer) => {
        // cut LAYER0_7
        const layerNumber = layerId.substring(0, layerId.indexOf('_') + 2);
        return layer.id().includes(layerNumber);
      });

      layerMembers.forEach((layer) => {
        const path = (layer.type === 'g') ? layer.select('path').get(0) : layer;
        if (path) {
          if (layer.id().includes('STROKE')) {
            path.style({ stroke: newColor.hex });
          } else if (layer.id().includes('FILL')) {
            path.style({ fill: newColor.hex });
          }
        }
      });
    },
  }
};

export default SvgMixin;
